import type { FC } from "react";
import { Navigate } from "react-router";

/**
 * Redirects to the dashboard (Overview) tab for the performance dashboard.
 */
export const PerformanceDefaultRedirect: FC = () => {
  return <Navigate to="dashboard" replace />;
};
